module.exports = __webpack_public_path__ + "static/AdminRequest-a65dbe0aa400c7f0b7fafbdd89aa31ce.png";